export default {"src":"/_next/static/media/woman-thumbs-up-2.mono.e9ae6ab8.svg","height":364,"width":364,"blurWidth":0,"blurHeight":0};